import { compose } from 'ramda';
import { connect } from 'react-redux';

import { trackRegionClick } from './tracking';
import { getModalTitle } from './utils/getModalTitle';
import { closePopup, EPopupType, getLocations, openPopup, setLocation } from '../../actions/geoLocation';
import { GeoLocationModal, IGeoLocationModalProps } from '../../components/GeoLocationModal';
import { IApplicationContext } from '../../types/application';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { withApplicationContext } from '../ApplicationContext';

type TGeoLocationModalStateProps = Pick<IGeoLocationModalProps, 'locations' | 'open' | 'title'> & {
  popupType: EPopupType | null;
};
type TGeoLocationModalDispatchProps = Pick<
  IGeoLocationModalProps,
  'getLocations' | 'onClose' | 'setLocation' | 'openPopup'
>;

export function mapStateToProps(state: IApplicationState): TGeoLocationModalStateProps {
  return {
    locations: state.geoLocation.locations,
    title: getModalTitle(state.geoLocation.popup.type),
    popupType: state.geoLocation.popup.type,
    open: state.geoLocation.popup.isOpen,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TGeoLocationModalDispatchProps {
  return {
    getLocations: () => dispatch(getLocations()),
    setLocation: (regionId: number, regionName: string, mainTownRegionId?: number | null) =>
      dispatch(setLocation(regionId, regionName, mainTownRegionId)),
    onClose: () => dispatch(closePopup()),
    openPopup: () => dispatch(openPopup(EPopupType.GeoChanger)),
  };
}

export function mapContextToProps(context: IApplicationContext): Pick<IApplicationContext, 'eventQueue'> {
  return {
    eventQueue: context.eventQueue,
  };
}

export function mergeProps(
  stateProps: TGeoLocationModalStateProps,
  dispatchProps: TGeoLocationModalDispatchProps,
  ownProps: Pick<IApplicationContext, 'eventQueue'>,
): IGeoLocationModalProps {
  const { popupType, ...otherStateProps } = stateProps;
  const { setLocation: dispatchSetLocation, ...otherDispatchProps } = dispatchProps;

  return {
    ...otherStateProps,
    ...otherDispatchProps,
    ...ownProps,
    setLocation: (regionId: number, regionName: string, mainTownRegionId?: number | null) => {
      trackRegionClick(regionName);

      if (popupType === EPopupType.QuickSearch) {
        setTimeout(() => {
          window.location.href = `/nd/search/?deal_type=sale&engine_version=2&offer_type=flat&region=${regionId}`;
        }, 300);

        return;
      }

      dispatchSetLocation(regionId, regionName, mainTownRegionId);
    },
  };
}

export const GeoLocationModalContainer = compose(
  withApplicationContext(mapContextToProps),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(GeoLocationModal);
